import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Home() {
  const { isAuthenticated } = useAuth();

  return (
    <div>
      {/* Hero */}
      <section className="hero">
        <h1>knoukno.org<br />Build a Business That Is Ready to Make Money</h1>
        <p>
          Kno U Kno helps you think like a serious business owner. You do not guess your way forward.
          You answer strong questions, measure your thinking, and improve your decisions before they
          become expensive mistakes.
        </p>
        <div className="hero-actions">
          {isAuthenticated ? (
            <Link to="/dashboard" className="btn btn-primary btn-lg">Go to Dashboard</Link>
          ) : (
            <>
              <Link to="/register" className="btn btn-primary btn-lg">Start Free Trial</Link>
              <Link to="/about" className="btn btn-secondary btn-lg">Learn More</Link>
            </>
          )}
        </div>
      </section>

      <section className="features" style={{ paddingTop: '2rem' }}>
        <div className="card" style={{ maxWidth: '960px', margin: '0 auto' }}>
          <h2 style={{ marginBottom: '1rem' }}>How to Get a Business Working: Money and Law First</h2>
          <p style={{ lineHeight: 1.85, marginBottom: '0.9rem' }}>
            A business idea is not enough. To become profitable, your business must be built on strong money
            decisions and legal clarity. Money controls survival. Law protects what you build. If either side is weak,
            growth becomes risky. Kno U Kno gives you a practical way to strengthen both.
          </p>
          <p style={{ lineHeight: 1.85, marginBottom: '0.9rem' }}>
            On knoukno.org, the system gives you focused business questions one at a time. The questions are written
            to make you think clearly about revenue, expenses, contracts, pricing, taxes, compliance, hiring,
            operations, and customer risk. Every question includes a realistic example so you can apply it to your own
            situation. You answer in your own words. This is not multiple choice. This is decision training.
          </p>
          <p style={{ lineHeight: 1.85, marginBottom: '0.9rem' }}>
            After you answer, you grade yourself, rate relevance, and store your response. Your results are tracked,
            and your averages help you see whether your business thinking is improving. Over time, you can compare
            old and new answers, find weak areas, and improve your action plan. This process turns uncertainty into a
            repeatable system.
          </p>
          <p style={{ lineHeight: 1.85, marginBottom: '0.9rem' }}>
            The platform is simple: the AI writes the questions, the client writes the answers, and the system saves
            progress in MongoDB. React powers the frontend experience. JWT protects account access and keeps your
            session secure. Questions are paginated and separated so you stay focused, one business decision at a time.
          </p>
          <p style={{ lineHeight: 1.85, marginBottom: 0 }}>
            If you want to launch, stabilize, or scale with confidence, start here. Train your thinking before you spend
            more money. Improve your legal and financial judgment before pressure forces bad choices. Kno U Kno helps
            you prepare your business to move from idea to income.
          </p>
        </div>
      </section>

      {/* Features */}
      <section className="features">
        <h2>Everything You Need to Build a Stronger Business</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📚</div>
            <h3>175 Guided Questions</h3>
            <p>
              Real-world business scenarios covering money, law, operations, employees, and growth.
              Every question includes context so you can apply it to your own business.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Client-Written Answers</h3>
            <p>
              AI provides the question. You provide the answer. This builds practical decision skill,
              not passive reading.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Grade, Rate, and Average</h3>
            <p>
              Grade each answer, rate relevance, and track averages to see where your business
              knowledge is strong and where it needs work.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🏷️</div>
            <h3>Tiered Access Plans</h3>
            <p>
              Start free for 3 days with 5 questions. Members unlock questions 1 to 50 with bonus access through 150.
              Pro unlocks questions 1 to 75 with bonus access through 175.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🗂️</div>
            <h3>Question Pagination</h3>
            <p>
              Questions are separated and paginated to keep your focus on one answer at a time.
              Review, revise, and move forward with control.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>React + JWT + MongoDB</h3>
            <p>
              Fast React frontend, JWT-based auth, and MongoDB data storage for secure,
              reliable business training.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--color-primary)', padding: '4rem 1.5rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.9rem', fontWeight: 800, color: 'var(--color-dark)', marginBottom: '0.75rem' }}>
            Ready to Know Your Business Better?
          </h2>
          <p style={{ color: 'var(--color-text-light)', marginBottom: '1.75rem', fontSize: '1.05rem' }}>
            Start your 3-day free trial today. No credit card required.
          </p>
          <div className="hero-actions">
            {isAuthenticated ? (
              <Link to="/dashboard" className="btn btn-primary btn-lg">Open Dashboard</Link>
            ) : (
              <>
                <Link to="/register" className="btn btn-primary btn-lg">Start Free — 3 Days</Link>
                <Link to="/price" className="btn btn-outline btn-lg">See Pricing</Link>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
